<div class="w-full space-y-6 animate-fade-in">
  <!-- Welcome Text -->
  <div class="text-center md:text-left">
    <h2 class="text-2xl font-bold text-greyscale-900 mb-2">
      {{ "forgotPasswordPage.forgotPassword" | transloco }}
    </h2>
  </div>

  <!-- Form -->
  <form
    class="flex flex-col gap-4"
    [formGroup]="profilForm"
    (ngSubmit)="onForgotPassword()"
  >
    <p-iconField iconPosition="left" styleClass="w-full">
      <p-inputIcon styleClass="pi pi-user" />
      <input
        class="w-full"
        type="email"
        name="email"
        [attr.placeholder]="'forgotPasswordPage.email' | transloco"
        formControlName="email"
        pInputText
      />
    </p-iconField>
    <small
      class="text-error-600"
      [ngClass]="isEmailInvalid ? 'visible' : 'invisible'"
      >{{ "forgotPasswordPage.invalidEmailFormat" | transloco }}</small
    >

    <button
      class="flex w-full items-center justify-center rounded-md border border-transparent bg-primary-500 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
      data-testid="forgot-password-button"
      [disabled]="loading"
      type="submit"
    >
      @if (loading) {
        <i class="pi pi-spin pi-spinner mr-2"></i>
      } @else {
        <i class="pi pi-send mr-2"></i>
      }
      {{ "forgotPasswordPage.createNewPassword" | transloco }}
    </button>
  </form>

  <!-- Links -->
  <div class="flex flex-col items-center md:items-start gap-2">
    <a
      class="text-sm font-medium text-primary-600 no-underline hover:text-primary-500 flex items-center"
      routerLink="/auth/login"
    >
      <i class="pi pi-arrow-left mr-2"></i>
      {{ "forgotPasswordPage.backToLogin" | transloco }}
    </a>
  </div>

  <p-toast />
</div>
